<template>
  <div class="login" style="height: 100%">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">OpenP2P {{ $t("reg.title") }}</h2>
      </div>
      <div class="weui-form__control-area" style="
          max-width: 500px;
          display: block;
          margin-left: auto;
          margin-right: auto;
        ">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("reg.username") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="username" autofocus="autofocus" class="weui-input" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("reg.password") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="password" type="password" class="weui-input" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{
                  $t("reg.passwordConfirm")
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="password2" type="password" class="weui-input" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("phone") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="phone" class="weui-input" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("email") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="email" class="weui-input" :placeholder="emailHolder" />
              </div>
            </div>
          </div>
        </div>

        <div class="weui-cell weui-cell_active">
          <label class="weui-agree">
            <input type="checkbox" v-model="agreed" />
            <span>
              {{ $t("reg.agreeTerms") }}
              <a href="/agreement">{{ $t("reg.userAgreement") }}</a>
            </span>
          </label>
        </div>
        <div class="weui-form__opr-area" style="display: flex; align-items: center; justify-content: space-between;">
          <!-- Agreement checkbox -->

          <a class="weui-btn weui-btn_primary" v-on:click="register" href="javascript:">{{ $t("reg.register") }}</a>
        </div>
      </div>

      <div class="weui-form__extra-area">
        <div class="weui-footer">
          <p class="weui-footer__text">Copyright © 2024 openp2p.cn</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import weui from "weui.js"
import * as err from "../error.js"
export default {
  name: "Register",
  data() {
    return {
      username: "",
      password: "",
      password2: "",
      phone: "",
      email: "",
      emailHolder: this.$t("reg.emailTips"),
      agreed: false, // Track if terms are agreed
    }
  },
  props: {
    msg: String,
  },
  methods: {
    register() {
      let _this = this
      window.debugLog("vue register")
      if (!this.agreed) {
        weui.alert(this.$t("reg.agreeTermsFirst"));
        return;
      }
      if (this.password != this.password2) {
        weui.alert(this.$t("reg.pwdDiff"))
        return
      }
      if (this.password.length < 8 || this.username.length < 8) {
        weui.alert(this.$t("reg.tooShort"), {
          buttons: [
            {
              label: this.$t("ok"),
            },
          ],
        })
        return
      }
      axios
        .post(this.$ServerHost + "/api/v2/user/register", {
          user: this.$data.username,
          password: this.$data.password,
          phone: this.$data.phone,
          email: this.$data.email,
        })
        .then((response) => {
          window.debugLog("rsp:" + response)
          if (response.status == 200 && response.data.error == 0) {
            weui.alert(
              _this.$t("reg.registerOK"),
              function () {
                localStorage.setItem("token", response.data.token)
                axios.defaults.headers.common["Authorization"] =
                  response.data.token
              },
              {
                buttons: [
                  {
                    label: _this.$t("ok"),
                  },
                ],
              }
            )
            _this.$router.replace("/")
          } else {
            window.debugLog("register error:", response)
            var errDetail
            if (response.data.error == err.ErrUserBeenUsed) {
              errDetail = _this.$t("reg.userBeenUsed")
            }
            if (response.data.error == err.ErrEmailorPhoneBeenUsed) {
              errDetail = _this.$t("reg.emailOrPhoneBeenUsed")
            }
            weui.alert(_this.$t("reg.registerError") + ":" + errDetail, {
              buttons: [
                {
                  label: _this.$t("ok"),
                },
              ],
            })
          }
        })
        .catch((response) => {
          window.debugLog(response)
          weui.alert(_this.$t("reg.registerError"), {
            buttons: [
              {
                label: _this.$t("ok"),
              },
            ],
          })
        })
    },
  },
}
</script>

<style scoped>
@import "../assets/css/weui.scss";

.weui-label {
  display: block;
  width: 9.5rem;
  word-wrap: break-word;
  word-break: break-all;
}
</style>